// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GBJU","content":"styles_content__2rVQL"};